import React, { useEffect } from "react";
import AppText from "./AppText";
import { appStrings } from "./strings";
import Button from "../../presentational/Button";
import Input from "../../presentational/Input";
import Links from "./Links";
import { useTurnstile } from "../../../hooks/useTurnstile";
interface ForgotPasswordProps {
    email: string;
    serverError: string;
    isLoading: boolean;
    setEmail: (email: string) => void;
    forgotPassword: (email: string) => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ email, serverError, isLoading, setEmail, forgotPassword }) => {
    useTurnstile();

    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        forgotPassword(email);
        return false;
    };

    return (
        <main>
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        <img
                            className="form-header-logo"
                            src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg"
                            alt="MyDataHelps Designer Logo"
                        />
                        <h2>
                            <AppText textKey="forgot-password-title" />
                        </h2>
                        <p className="small-print">
                            <AppText textKey="forgot-password-text" />
                        </p>
                    </div>
                    <div className="field-group">
                        <label className="field-group" htmlFor="username">
                            <AppText textKey="username-label" />
                        </label>
                        <Input
                            disabled={isLoading}
                            fullWidth={true}
                            inputClassName="admin-input"
                            id="username"
                            value={email}
                            onChange={handleChangeEmail}
                            type="text"
                            placeholder={appStrings["username-placeholder"]}
                            autoComplete="username"
                            autoFocus={true}
                            htmlAttributes={{
                                spellCheck: false,
                                autoCorrect: "off",
                                autoCapitalize: "none",
                            }}
                        />
                    </div>
                    <div className="field-group">
                        <div id="cf-turnstile" className="cf-turnstile"></div>
                    </div>
                    <Button
                        onClick={handleSubmit}
                        disabled={!email}
                        className="primary-button editor-controls-button"
                        loading={isLoading}
                        intent="primary"
                        type="submit"
                    >
                        <AppText textKey="next-label" />
                    </Button>
                </form>
                <Links forceIsLogin={true} />
            </div>
        </main>
    );
};

export default ForgotPassword;
